// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"c157818b","498":"6f06de91","703":"841a0854","787":"25e8aa70"}[chunkId] + ".chunk.js";
};